import { UserDocumentStatusEnum } from '../model';

export const getDocumentLabelByStatus = (docStatus: UserDocumentStatusEnum): string => (
  {
    [UserDocumentStatusEnum.Approved]: 'Reviewed',
    [UserDocumentStatusEnum.NotReviewed]: 'Not reviewed',
    [UserDocumentStatusEnum.OnHold]: 'Not reviewed',
    [UserDocumentStatusEnum.Declined]: 'Declined',
  }[docStatus] ?? ''
);